import { useEffect, useRef, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import Dynamsoft from 'dwt';

import { WebTwain } from 'dwt/dist/types/WebTwain';

import { Button, Card, CardContent, CardHeader, Chip, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, Grid, IconButton, InputLabel, MenuItem, Select, Typography } from '@mui/material';

import { GrCheckmark } from "react-icons/gr";
import { GrPrevious } from "react-icons/gr";
import { MdDelete } from "react-icons/md";
import { CgPlayListRemove } from "react-icons/cg";

import ScannerIcon from '@mui/icons-material/Scanner';
import FileUploadIcon from '@mui/icons-material/FileUpload';

import { RootState } from '../../../store';
import { openSnackbar } from "../../../store/slices/SnackbarSlice";

import { DialogContentStyle, DialogActionsStyle } from '../../../styles/DialogStyle';

import { ActualizarEstatus } from '../../../connections/comun/RecepcionConnection';

interface Props {
    numeroSeguimiento:      number;    
    handleBack:             () => void;
    setMensajeFinalizacion: React.Dispatch<React.SetStateAction<string>>;
    setMensajeAsignacion:   React.Dispatch<React.SetStateAction<string>>;
    setAjaxFinish:          React.Dispatch<React.SetStateAction<boolean>>;
}

const DigitalizarDocumentosPage = ( { numeroSeguimiento, handleBack, setMensajeFinalizacion, setMensajeAsignacion, setAjaxFinish }: Props ) => {

    const dispatch = useDispatch();

    const { id } = useSelector( ( state: RootState ) => state.recepcion );

    const loadPage = useRef( false );

    const containerId = 'dwtcontrolContainer';
    const width = "100%";
    const height = "500";
   
    const [DWObject, setDWObject] = useState<WebTwain>();
    const [scanners, setScanners] = useState<string[]>( [] );
    const [currentScanner, setCurrentScanner] = useState( "0" );
    const [twainReady, setTwainReady] = useState( false );    
    
    const [loadingBack, setLoadingBack] = useState( false ); 
    const [loadingFinish, setLoadingFinish] = useState( false ); 

    const [countPages, setCountPages] = useState( 0 ); 

    const [openConfirmacion, setOpenConfirmacion] = useState( false ); 
    const [openConfirmacionAll, setOpenConfirmacionAll] = useState( false ); 

    const ReadyTwain = () => {

        Dynamsoft.DWT.ProductKey = process.env.REACT_APP_API_KEY_DYNAMIC_TWAIN ?? '';        
        Dynamsoft.DWT.ResourcesPath = "../../dwt-resources";
        Dynamsoft.DWT.Containers = [ { ContainerId: containerId, Width: width, Height: height } ];
        
        Dynamsoft.DWT.RegisterEvent('OnWebTwainReady', () => {
            setDWObject( Dynamsoft.DWT.GetWebTwain( containerId ) );
        });

        checkScriptLoaded();
    }    

    const checkScriptLoaded = () => {    
            
        if ( !twainReady ) {     

            if( loadPage.current === false ){

                Dynamsoft.DWT.Load().then( resp => {

                    if( resp === undefined ){

                        setTwainReady( true );
                        loadPage.current = true;

                    }


                });

            }
            
        } 
        else {
            setTimeout(() => {
                checkScriptLoaded();               
            }, 700);
        }
    }

    const onSourceChange = ( value: string ) => {
        setCurrentScanner( value );
    }

    const acquireImage = async () => {

        if( DWObject ){

            DWObject.CloseSource();
            
            for (let i = 0; i < DWObject.SourceCount; i++) {
                if ( DWObject.GetSourceNameItems(i) === currentScanner) {
                    DWObject.SelectSourceByIndex(i);
                    break;
                }
            }
    
            DWObject.IfDuplexEnabled = false;
            DWObject.IfFeederEnabled = true;
            DWObject.IfShowUI = true;
            DWObject.PixelType = Dynamsoft.DWT.EnumDWT_PixelType.TWPT_BW;
            DWObject.Resolution = 300;
    
            DWObject.OpenSource();
            
            DWObject.AcquireImage( () => { setCountPages( DWObject.HowManyImagesInBuffer ); });     

        }

    }

    const GuardarDigitalizacion = () => {        

        setLoadingFinish( true );
        
        if ( DWObject ) {          
            
            if ( DWObject.HowManyImagesInBuffer > 0 ){

                const strHTTPServer = window.location.hostname;				
                const strActionPage = `Api/Amparo/GuardarDigitalizacion/${ id }`;
                
                if( window.location.protocol === 'http:' ){
                    DWObject.IfSSL = true;
                    DWObject.HTTPPort = 5001;
                }
                else if( window.location.protocol === 'https:' ){
                    DWObject.IfSSL = true;
                }      

                const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

                if( data ){
                    const { token } = data;

                    DWObject.SetHTTPHeader( 'Authorization', 'Bearer ' + token);
                    DWObject.SetHTTPHeader( 'Access-Control-Allow-Origin', '*');
                }               
                
                DWObject.HTTPUploadAllThroughPostAsPDF(strHTTPServer, strActionPage, "documento.pdf", OnHttpUploadSuccess, OnHttpUploadFailure);	
            }
            else{
                
                dispatch( openSnackbar({ message: 'Debe escanear o subir el documento', variant: 'warning' }));    
                setLoadingFinish( false );

            }  

        }

    }

    const OnHttpUploadSuccess = () => handleFinalizar()

    const OnHttpUploadFailure = ( errorCode: number, _: string, sHttpResponse: string ) => {

        dispatch( openSnackbar({ message: `Code: ${ errorCode }, ${ sHttpResponse }`, variant: 'error' }));    
        setLoadingFinish( false );

    }
    
    const loadImagesOrPDFs = () => {

        if( DWObject ){          

            DWObject.IfShowFileDialog = true;
            DWObject.Addon.PDF.SetReaderOptions({ convertMode: 1, renderOptions: { resolution: 200 } });

            DWObject.LoadImageEx("", 5, () => { setCountPages( DWObject.HowManyImagesInBuffer ); }, ( errorCode, errorString ) =>  dispatch( openSnackbar({ message: `Code: ${ errorCode }, ${ errorString }`, variant: 'error' }) ) );            
        }

    }   
    
    const handleRegresar = async () => {
  
        setLoadingBack( true );

        await ActualizarEstatus({ id: id ?? '', idEstatus: 7 }).then( resp => {
                
            const { success, message, usuarioAsignacion, usuarioActualAsignacion } = resp;

            if( success ){

            setTimeout(() => {
                
                if( usuarioActualAsignacion ){
                    handleBack();
                    setLoadingBack( false );
                }
                else{                        
                    setAjaxFinish( true );
                    setMensajeAsignacion( 'La siguiente actividad se asignó a ' + ( usuarioAsignacion ?? '' ) );  
                }
                
            }, 700);

            }
            else {

                setTimeout(() => {
                 
                    dispatch( openSnackbar({ message: message, variant: 'error' }));                         
                    setLoadingBack( false );

                }, 700);

            }

        }); 
 
     }

    const handleRemoveImage = () => {

        DWObject?.RemoveAllSelectedImages();

        setCountPages( (prev) => prev - 1 );
        setOpenConfirmacion( false );

    }

    const handleRemoveAllImages = () => {

        DWObject?.RemoveAllImages();

        setCountPages( 0 );
        setOpenConfirmacionAll( false );
    }

    const handleFinalizar = async () => {
        
        await ActualizarEstatus({ id: id ?? '', idEstatus: 9 }).then( resp => {

            const { success, message } = resp;

            if( success ){

                setTimeout(() => {
                    
                    setMensajeFinalizacion( 'No se tienen actividades pendientes para este trámite' );
    
                    setAjaxFinish( true );
                    setLoadingFinish( false );

                }, 700);

            }
            else {

                setTimeout(() => {
                    
                    dispatch( openSnackbar({ message: message, variant: 'error' }));    
                    setLoadingFinish( false );
                    
                }, 700);

            }

        });       
    
    }

    useEffect(() => {
        
        if ( DWObject ) {

            const vCount = DWObject.SourceCount;
            let sourceNames = [];

            for (let i = 0; i < vCount; i++){
                sourceNames.push( DWObject.GetSourceNameItems(i) );
            }

            setScanners( sourceNames );

        }

    }, [ DWObject ]);
       
    if( !twainReady ){     
        ReadyTwain();
    }

    return (

        <Card sx={{ mt: 2 }}>
        
            <CardHeader 
                sx={{ backgroundColor: (theme) => theme.palette.primary.main }} 
                subheader={ 
                    <Grid container spacing={3}>

                        <Grid size={{ md: 6, xs: 6 }}>                                                                    
                            <Typography variant='h6' sx={{ color: 'white' }}> Escanear documento(s) </Typography> 
                        </Grid>
                    
                        <Grid size={{ md: 6, xs: 6 }} sx={{ textAlign: 'end' }}>
                            <Chip variant='filled' sx={{ bgcolor: 'white', borderRadius: 2, p: 2 }} label={ <Typography variant='h6'> RT-{ numeroSeguimiento } </Typography>  } />
                        </Grid>

                    </Grid>
                }
            />

            <CardContent sx={{ p: 3 }}>
                                                        
                <Grid container spacing={3}>

                    <Grid size={{ md: 12, xs: 12 }}>

                        <Grid container spacing={3}>

                            <Grid size={{ md: 6, xs: 12 }}>

                                <Grid container spacing={3} sx={{ }}>

                                    <Grid size={{ md: 12, xs: 12 }} sx={{ position: 'relative' }}>

                                        <div 
                                            id={ containerId }
                                            style={{
                                                width: '100%',  
                                                border: 'none', 
                                                boxShadow: "0px 0px 5px rgba(0, 0, 0, 0.2)", 
                                                height: 500,
                                                backgroundColor: '#f5f5f5'
                                            }}
                                        >

                                        </div>

                                        {
                                            countPages !== 0
                                            &&
                                                <IconButton
                                                    sx={{ 
                                                        position: 'absolute', 
                                                        bottom: 10, 
                                                        right: 85, 
                                                        bgcolor: '#0A192D', 
                                                        color: 'white',
                                                        ':hover' : {
                                                            bgcolor: 'rgba(0, 0, 0, 0.8)', 
                                                        }
                                                    }}    
                                                    onClick={ () => setOpenConfirmacion( true ) }             
                                                >
                                                    <MdDelete />
                                                </IconButton>
                                        }

                                        {
                                            countPages !== 0
                                            &&
                                                <IconButton
                                                    sx={{ 
                                                        position: 'absolute', 
                                                        bottom: 10, 
                                                        right: 30, 
                                                        bgcolor: '#0A192D', 
                                                        color: 'white',
                                                        ':hover' : {
                                                            bgcolor: 'rgba(0, 0, 0, 0.8)', 
                                                        }
                                                    }}            
                                                    onClick={ () => setOpenConfirmacionAll( true ) }                
                                                >
                                                    <CgPlayListRemove />
                                                </IconButton>
                                        }                                

                                    </Grid>                    
                                
                                    <Grid size={{ md: 12, xs: 12 }}>
                                        <Typography variant='subtitle2' fontWeight={'bold'}> Número de hojas: { countPages } </Typography>
                                    </Grid>  

                                </Grid>

                            </Grid>
                            
                            <Grid size={{ md: 6, xs: 12 }}>

                                <Grid container spacing={3} >

                                    <Grid size={{ md: 12, xs: 12 }}>
                                    
                                        <FormControl fullWidth>
                                            <InputLabel id="select-impresoras-label">Impresora(s) disponible(s)</InputLabel>
                                    
                                            <Select 
                                                label="Impresora(s) disponible(s)"
                                                labelId="select-impresoras-label"
                                                value={ currentScanner } 
                                                onChange={ (e) => onSourceChange( e.target.value ) } >
                                                
                                                <MenuItem value="0" key="0"> Seleccione una impresora </MenuItem>
                                                
                                                {
                                                    scanners.length > 0 
                                                    && 
                                                    (
                                                        scanners.map((_name, _index) =>
                                                            <MenuItem value={_name} key={_index}> {_name} </MenuItem>
                                                        )
                                                    )
                                                }
                                            </Select>
                                        </FormControl>

                                    </Grid>

                                    <Grid size={{ md: 6, xs: 12 }}> 
                                        <Button 
                                            fullWidth
                                            variant="contained" 
                                            onClick={ acquireImage } 
                                            disabled={ currentScanner === "0" || DWObject === null }
                                            startIcon={ <ScannerIcon /> }
                                        >
                                            Escanear
                                        </Button>
                                    </Grid>     
                                    
                                    <Grid size={{ md: 6, xs: 12 }}> 
                                        <Button
                                            fullWidth
                                            variant="contained" 
                                            color='inherit'
                                            startIcon={ <FileUploadIcon /> }
                                            onClick={ loadImagesOrPDFs }
                                            disabled={ DWObject === null }
                                        >
                                            Subir archivo                
                                        </Button>
                                    </Grid>                       

                                </Grid>   

                            </Grid>
                        
                        </Grid>

                    </Grid>

                    <Grid size={{ md: 12, xs: 12 }} sx={{ mt: 1 }}>  

                        <Grid container >

                            <Grid size={{ md: 6, xs: 6 }} style={{ textAlign: 'left' }}>

                                <IconButton
                                    color='primary'
                                    onClick={ handleRegresar }
                                    loading={ loadingBack }
                                >
                                    <GrPrevious />
                                </IconButton>

                            </Grid>

                            <Grid size={{ md: 6, xs: 6 }} style={{ textAlign: 'right' }}>  

                                <Button 
                                    variant='contained'
                                    startIcon={ <GrCheckmark /> }
                                    onClick={ GuardarDigitalizacion }
                                    loading={ loadingFinish }
                                > 
                                    Finalizar
                                </Button>

                            </Grid>                                        
                            
                        </Grid>

                    </Grid>

                    <Dialog 
                        open={ openConfirmacion } 
                        onClose={ () => { } }                 
                        maxWidth='xs' 
                        fullWidth={true}
                        disableEscapeKeyDown
                    >

                        <DialogTitle>
                            Confirmación
                        </DialogTitle>

                        <DialogContent sx={ DialogContentStyle }>

                            <DialogContentText>
                                ¿Desea quitar la página actual?
                            </DialogContentText>

                        </DialogContent>

                        <DialogActions sx={ DialogActionsStyle }>
                            <Button color='secondary' onClick={ () => setOpenConfirmacion( false ) }> Cancelar </Button>
                            <Button onClick={ handleRemoveImage } variant='contained' > Aceptar </Button>
                        </DialogActions>
                    </Dialog>

                    <Dialog 
                        open={ openConfirmacionAll } 
                        onClose={ () => { } }               
                        maxWidth='xs' 
                        fullWidth={true}
                        disableEscapeKeyDown
                    >

                        <DialogTitle>
                            Confirmación
                        </DialogTitle>

                        <DialogContent sx={ DialogContentStyle }>

                            <DialogContentText>
                                ¿Desea quitar todas la paginas?
                            </DialogContentText>

                        </DialogContent>

                        <DialogActions sx={ DialogActionsStyle }>
                            <Button color='secondary' onClick={ () => setOpenConfirmacionAll( false ) }> Cancelar </Button>
                            <Button onClick={ handleRemoveAllImages } variant='contained' > Aceptar </Button>
                        </DialogActions>
                    </Dialog>

                </Grid>
        
            </CardContent>

        </Card>    
    )
}

export default DigitalizarDocumentosPage;